module.exports = __webpack_public_path__ + "static/media/iconSiguiente.2bc504c9.svg";